import { Link } from 'react-router-dom';
import styled from 'styled-components';

import {
  colorBlack200,
  colorBlack900,
  colorGrey100,
  colorLink400,
  colorPrimary400,
  colorWhite,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryDesktopMin,
  mediaQueryLaptopMin,
  mediaQueryMobileLargeMin,
  mediaQueryTabletMin,
} from '@/styleUtils';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 16px;
`;

export const ProductMainInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    gap: 24px;
  }

  @media ${mediaQueryTabletMin} {
    gap: 32px;
  }
`;

export const ButtonBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media ${mediaQueryMobileLargeMin} {
    margin: 0 auto;
    min-width: 284px;
  }

  @media ${mediaQueryTabletMin} {
    min-width: 340px;
    padding: 0 16px;
  }

  @media ${mediaQueryTabletMin} {
    padding: 0;
  }
`;

export const ProductDetails = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 16px;

  @media ${mediaQueryTabletMin} {
    display: flex;
    gap: 24px;
    flex-wrap: nowrap;
  }
`;

export const ProductDetail = styled.div`
  display: flex;
  flex-flow: column;

  @media ${mediaQueryDesktopMin} {
    min-width: calc(33% - 15px);
    width: max-content;
  }
`;

export const ProductDetailValue = styled.strong`
  color: ${colorBlack900};
  font: 700 20px/24px ${fontFamilyPrimary};
  white-space: nowrap;
  display: flex;
  align-items: baseline;
  gap: 4px;

  span {
    font: 700 12px/24px ${fontFamilyPrimary};
    width: max-content;
  }
`;

export const ProductDetailCaption = styled.span`
  color: ${colorBlack200};
  font: 400 12px/16px ${fontFamilyPrimary};
  margin-bottom: 4px;
  width: max-content;
  @media ${mediaQueryLaptopMin} {
    margin-bottom: 8px;
  }
`;

export const ProductTitle = styled.p`
  color: ${colorBlack900};
  font: 400 12px/16px ${fontFamilyPrimary};
  letter-spacing: 0.36px;
`;

export const ProductOrderInfo = styled.div`
  display: flex;
  flex-flow: row wrap;
  white-space: nowrap;
  width: 100%;
  justify-content: center;
  order: 10;
  align-content: flex-start;
  flex-shrink: 0;

  @media ${mediaQueryMobileLargeMin} {
    order: inherit;
  }

  @media ${mediaQueryMobileLargeMin} {
    width: 140px;
  }
`;

export const ProductOrderBtn = styled.button`
  align-self: flex-start;
  background-color: ${colorPrimary400};
  border: 0;
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 16px;
  outline: none;
  padding: 2px 8px 6px;
  width: 100%;
  transition: opacity 0.3s ease;
  text-align: center;
  border-radius: 4px;

  &:hover,
  &:active {
    opacity: 0.8;
  }

  &[data-type='empty'] {
    font: 700 14px/24px ${fontFamilySecondary};
    background-color: rgba(0, 0, 0, 0);
    border: 1px solid ${colorPrimary400};
    color: ${colorPrimary400};
    padding: 11px 16px;
    justify-content: center;
  }
`;

export const ProductOrderBtnCaption = styled.strong`
  color: ${colorWhite};
  font: 700 14px/24px ${fontFamilyPrimary};
  width: 100%;
`;

export const ProductOrderBtnCompanyName = styled.strong`
  font: 400 13px/16px ${fontFamilyPrimary};
  color: rgba(255, 255, 255, 0.7);
  display: block;
  letter-spacing: 0.13px;
  max-width: calc(100% - 16px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 auto;
`;

export const ProductCharacteristicsBtn = styled.button`
  background-color: rgba(0, 0, 0, 0);
  border: 0;
  font: 400 14px/16px ${fontFamilyPrimary};
  color: ${colorBlack200};
  letter-spacing: 0.02em;
  outline: none;
  padding: 4px;

  &::after {
    content: '';
    border-bottom: 2px solid ${colorBlack200};
    border-right: 2px solid ${colorBlack200};
    display: inline-flex;
    height: 7px;
    margin-left: 4px;
    position: relative;
    top: -4px;
    transform: rotate(45deg);
    width: 7px;
  }

  &[data-active='true']::after {
    top: -2px;
    margin-left: 5px;
    transform: rotate(-135deg);
  }

  &:hover,
  &:active {
    opacity: 0.8;
  }
`;

export const ProductCharacteristicsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FoolInfoWrapper = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  transition: 0.2s;

  a:hover {
    opacity: 0.8;
  }
`;

export const FoolInfo = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;
  font: 600 13px/20px ${fontFamilyPrimary};
  color: ${colorBlack200};

  &:visited,
  &:hover {
    color: ${colorBlack200};
  }
`;

export const MoreInfoAboutBank = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;
  font: 600 13px/20px ${fontFamilyPrimary};
  color: ${colorLink400};

  &:visited,
  &:hover {
    color: ${colorLink400};
  }
`;

export const Table = styled.table`
  border-bottom: 1px solid ${colorGrey100};

  @media ${mediaQueryTabletMin} {
    margin: -12px 0 0;
  }
`;
